module.exports = __webpack_public_path__ + "img/inverter_disable.925a0e63.png";